// eslint-disable-next-line import/no-anonymous-default-export
export default {
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: 'none'
      }
    }
  }
}
